import React, { Component } from "react";
import _ from "lodash";
import getResultsById from "./getResultsById";
import getMergedResults from "./getMergedResults";
import ChartBar from "./charts/bar";

class ResultsWithCharts extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const resultsById = getResultsById(this.props.data);
    const mergeResult = getMergedResults(resultsById);
    return this.setState(mergeResult);
  }
  getLabelsfromFieldCollection(inputName) {
    const field = _.find(this.props.fieldcollection, [
      "inputName",
      inputName
    ]);
    if (!field || !field.answers) {
      return [];
    }
    return _.map(field.answers, answer => answer.label);
  }
  getPercentages(values) {
    return _.map(values, value => {
      return _.round((value * 100) / this.props.totalResults, 2);
    });
  }
  renderResults() {
    const keys = _.keysIn(this.state);
    return _.map(keys, (key, i) => {
      if (key === "null") {
        return null;
      }
      const labels = this.getLabelsfromFieldCollection(key);
      const values = this.getPercentages(_.values(this.state[key]));
      return (
        <div className="mb-2" key={i}>
          <ChartBar name={key} labels={labels} values={values} />
        </div>
      );
    });
  }
  render() {
    return <div className="mb-5">{this.renderResults()}</div>;
  }
}

export default ResultsWithCharts;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultsWithCharts/index.js